module.exports = __webpack_public_path__ + "static/media/dice-d10.0f1e264a.svg";